import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import {fromJS} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

const transportTypeOptions = fromJS([
  {id: "truck", label: "Truck"},
  {id: "container", label: "Container"},
]);

class CreateStockTransferForm extends Component {

  render() {
    let {errors, handleSubmit, submit, warehouses, transportTypes, submitting, submitLabel} = this.props;
    let label = submitting ? "Standby..." : (submitLabel || "Create");
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Origin Warehouse"
              name="originWarehouseId"
              component={DropDownInputField}
              data={warehouses}
              valueKey="id"
              titleKey="label"
              showBlank={true}
              serverError={this.props.errors.originWarehouseId}
              />
            <Field
              label="Destination Warehouse"
              name="destinationWarehouseId"
              component={DropDownInputField}
              data={warehouses}
              valueKey="id"
              titleKey="label"
              showBlank={true}
              serverError={this.props.errors.destinationWarehouseId}
              />
            <Field
              label="Transfer Type"
              name="transportType"
              component={DropDownInputField}
              data={transportTypes}
              valueKey="id"
              titleKey="label"
              showBlank={true}
              serverError={this.props.errors.transportType}
              />
            <Field
              label="Carrier Reference"
              name="carrierReference"
              component={TextInputField}
              serverError={this.props.errors.carrierReference}
              />
            <Field
              label="Purchase Order"
              name="purchaseOrder"
              component={TextInputField}
              serverError={this.props.errors.purchaseOrder}
              />
            <Field
              label="Order Date"
              name="orderDate"
              type="date"
              component={TextInputField}
              serverError={this.props.errors.orderDate}
              />
            <Field
              label="Expected Arrival"
              name="expectedArrivalDate"
              type="date"
              component={TextInputField}
              serverError={this.props.errors.expectedArrivalDate}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={label} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

CreateStockTransferForm.defaultProps = {
  transportTypes: transportTypeOptions,
};

const ReduxForm = reduxForm({
  form: "CreateStockTransferForm"
})(CreateStockTransferForm);

export default ReduxForm;
